/* clone-rv-timer: đồng hồ đếm ngược "evergreen" (tới nửa đêm theo giờ trình duyệt) hoặc tới một mốc cố định */
if (!customElements.get('rv-countdown')) {
  class RvCountdown extends HTMLElement {
    connectedCallback() {
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');
      this.mode = this.dataset.mode || 'midnight';
      this.fixedEnd = null;
      if (this.mode === 'fixed' && this.dataset.end) {
        const parsed = new Date(this.dataset.end.trim().replace(' ', 'T'));
        if (!isNaN(parsed.getTime())) this.fixedEnd = parsed;
      }
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    target(now) {
      if (this.mode === 'fixed') return this.fixedEnd;
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      return midnight;
    }

    tick() {
      const now = new Date();
      const end = this.target(now);
      let diff = end ? Math.max(0, Math.floor((end.getTime() - now.getTime()) / 1000)) : 0;

      if (diff === 0 && this.mode === 'fixed' && this.dataset.hideExpired === 'true') {
        const section = this.closest('.shopify-section');
        if (section && !window.Shopify?.designMode) section.style.display = 'none';
      }

      const hours = Math.floor(diff / 3600);
      diff -= hours * 3600;
      const minutes = Math.floor(diff / 60);
      const seconds = diff - minutes * 60;
      const pad = (n) => String(n).padStart(2, '0');

      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    }
  }

  customElements.define('rv-countdown', RvCountdown);
}
